import styled from 'styled-components';

import Container from 'components/styled/Container';

export const GoalsPageContainer = styled(Container)`
  display: grid;
  grid-gap: 15px;
`;
